import React, { useEffect, useState } from 'react';
import DataService from "../../../services/data.service";
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { useNotifications } from '../../../contexts/notificationContext';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { ItemTypeIdProps } from '../../../types/IdProps';
import AddItemTypeWorkflowRolePopup from '../Popups/ItemType_popup_AddWorkflowRole';

const ItemType_tab_WorkflowRoles: React.FC<ItemTypeIdProps> = ({ itemTypeId }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [itemTypeId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/WorkflowRoles/ByItemType/' + itemTypeId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/WorkflowRoles/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Name', dataProp: 'functionalRole.name', sort: 'asc' },
        { title: 'Required', dataProp: 'required', dataType: 'bool' },
        { title: 'Allow save without checkout', dataProp: 'functionalRole.allowSaveWithoutCheckout', dataType: 'bool' },
        { title: 'Begin date', dataProp: 'functionalRole.beginDate', dataType: 'date', width: 120, align: 'right' },
        { title: 'End date', dataProp: 'functionalRole.endDate', dataType: 'date', width: 120, align: 'right' },
    ];
    if (isAuthorizedForItemType(ApplicationFunctions.EditItemType, itemTypeId)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtItemTypeWorkflows'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Workflow role'
                navigateUrl='/plm/WorkflowSetup/WorkflowRole/'
            />
            {showPopup && <AddItemTypeWorkflowRolePopup itemTypeId={itemTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default ItemType_tab_WorkflowRoles;